export default __webpack_public_path__ + "assets/courier-promotion-animated-screen.gif";